import axiosInstance from "@/store/axios.instance";

export default {
    namespaced: true,
    state() {
        return {
            waarneming: null,
            waarnemingen: null,
            aantalPerWaarnemer: null,
        }
    },
    mutations: {
        setWaarnemingen(state, waarnemingen) {
            state.waarnemingen = waarnemingen
        },
        setWaarneming(state, waarneming) {
            state.waarneming = waarneming
        },
        setAantalPerWaarnemer(state,lijstAantal){
            state.aantalPerWaarnemer = lijstAantal
        }
    },
    actions: {
        fetchWaarnemingen({commit}) {
            axiosInstance.get('/zon/waarnemingen')
                .then(result => commit('setWaarnemingen', result.data))
        },
        async fetchAantalWaarnemingenPerWaarnemer({commit}){
            const result = await axiosInstance.get('/zon/waarnemingen/aantal/waarnemer')
            commit('setAantalPerWaarnemer', result.data)
        },
        async fetchWaarnemingenVanWaarnemer({ commit }, data) {
            const result = await axiosInstance.get('/zon/waarnemingen/waarnemer/' + data.waarnemerId)
            commit('setWaarnemingen', result.data)
            return result;
        },
        async fetchWaarnemingenVanWaarnemerVoorMaand({commit}, data) {
            const result = await axiosInstance.get('/zon/waarnemingen/waarnemer/' + data.waarnemerId + '/' + data.datum)
            commit('setWaarnemingen', result.data)
            return result;
        },
        async fetchWaarnemingenVanWaarnemerTussenDatums({commit}, data) {
            const result = await axiosInstance.get('/zon/waarnemingen/waarnemer/waarnemingen/datums/' + data.waarnemerId + '/' + data.start + '/' + data.einde)
            commit('setWaarnemingen', result.data)
            return result;
        },
        fetchWaarneming({commit}, id) {
            axiosInstance.get('/zon/waarnemingen/' + id)
                .then(result => commit('setWaarneming', result.data))
        },
        createWaarneming({commit, dispatch}, toeTeVoegenWaarneming) {
            const waarneemdata = {
                waarnemerId: toeTeVoegenWaarneming.waarnemerId,
                datum: toeTeVoegenWaarneming.datum.split("T")[0]
            }
            axiosInstance.post('/zon/waarnemingen/toevoegen', toeTeVoegenWaarneming)
                .then(result => {
                    commit('setWaarneming', result.data)
                    dispatch('fetchWaarnemingenVanWaarnemerVoorMaand', waarneemdata)
                })
                .catch(error => {
                    console.error("Error:", error.response?.data || error.message)
                })
        },
        createWaarnemingMetGroepen({commit, dispatch}, requestGroepen){
            const waarneemdata = {
                waarnemerId: requestGroepen.dataWaarnemingDto.waarnemerId,
                datum: requestGroepen.dataWaarnemingDto.datum.split("T")[0]
            }
            axiosInstance.post('/zon/waarnemingen/toevoegen/groepen',requestGroepen)
                .then(result => {
                commit('setWaarneming', result.data)
                dispatch('fetchWaarnemingenVanWaarnemerVoorMaand', waarneemdata)
            })
                .catch(error => {
                    console.error("Error:", error.response?.data || error.message)
                })
        },
        adjustWaarneming({commit, dispatch},waarnemingDto) {
            const waarneemdata = {
                waarnemerId: waarnemingDto.waarnemerId,
                datum: waarnemingDto.datum.split("T")[0]
            }
            axiosInstance.put('/zon/waarnemingen/aanpassen', waarnemingDto)
                .then(result => {
                    commit('setWaarneming', result.data)
                    dispatch('fetchWaarnemingenVanWaarnemerVoorMaand', waarneemdata)
                })
        },
        adjustWaarnemingGroepen({commit, dispatch},data) {
            const waarneemdata = {
                waarnemerId: data.requestGroepen.dataWaarnemingDto.waarnemerId,
                datum: data.requestGroepen.dataWaarnemingDto.datum.split("T")[0]
            }
            axiosInstance.put('/zon/waarnemingen/aanpassen/waarneming/groepen/' + data.waarnemingId, data.requestGroepen)
                            .then(result => {
                                commit('setWaarneming', result.data)
                                dispatch('fetchWaarnemingenVanWaarnemerVoorMaand', waarneemdata)
                            })
        },
        async deleteWaarneming({dispatch}, id) {
            await axiosInstance.put('/zon/waarnemingen/verwijder/waarneming/' + id)
        },
        async deleteWaarnemingenVanMaand({dispatch}, data) {
            await axiosInstance.put('/zon/waarnemingen/verwijder/waarnemingen/' + data.jaar + "/" + data.maand + "/" + data.waarnemerId)
        },
    },
    getters: {},
}